/* eslint-disable */
import React, {
 memo,
 useCallback,
 useEffect,
 useMemo,
 useRef,
 useState,
} from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import {
 FirstDataRenderedEvent,
 GridOptions,
 RowClassRules,
 RowHeightParams,
} from 'ag-grid-community';
import agGridLocale from '../translation/agGridLocale';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../store/store';
import DataGridDetails from './DataGridDetails';
import srv from '../../../services';
import { contractDetailData } from '../../../store/reducers/contractDetailDataSlice';
import { contractId } from '../../../store/reducers/contractIdSlice';
import { ContractConvertData } from './ContractConvertData';
import { shallowEqual } from 'react-redux';
import { RootState } from '../../../store/store';
import cloneDeep from 'lodash/cloneDeep';
import { Opacity } from '@mui/icons-material';
import AppealModel from '../models/AppealModel';

const useStyles = makeStyles({
 container: {
  width: '100%',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  overflow: 'auto',
  height: '100%',
 },
 agHeader: {
  justifyContent: 'center !important',
  '& .ag-root-wrapper': {
   borderRadius: '5px',
  },

  '& .ag-header': {
   backgroundColor: '#FFB614',
   color: 'white',
  },

  '& .ag-cell': {
   fontSize: '12px',
  },

  '& .ag-header-cell-label': {
   justifyContent: 'center !important',
   color: 'black',
   fontWeight: 400,
   fontSize: '12px',
  },

  '& .ag-text-field-input': {
   backgroundColor: 'white !important',
  },

  '& .ag-header-icon': {
   color: 'black !important',
   opacity: 1,
  },

  '& .ag-cell:focus': {
   border: 'none !important',
   outline: 'none',
  },

  '& .ag-row-selected': {
   backgroundColor: '#8180c3',
   color: 'black',
  },
  '& .ag-theme-alpine .ag-row-selected .ag-row-hover': {
   backgroundColor: 'red !important',
  },
  '& .MuiSvgIcon-root': {
   color: '#663d00',
   height: '20px',
  },

  '& .ag-theme-alpine .ag-row-selected': {
   backgroundColor: '#4abbff',
   height: '20px',
  },

  '& .ag-theme-alpine .ag-ltr .ag-cell-focus': {
   color: '#663d00',
  },
  '& .ag-root-wrapper.ag-layout-normal': {
   height: '100% !important',
  },
 },

 agHeaderShort: {
  justifyContent: 'center !important',
  '& .ag-root-wrapper': {
   borderRadius: '5px',
  },

  '& .ag-header': {
   backgroundColor: '#FFB614',
   color: 'black',
   Opacity: '1 !important',
  },

  '& .ag-cell': {
   fontSize: '12px',
  },

  '& .ag-header-cell-label': {
   justifyContent: 'center !important',
   color: 'black',
   fontWeight: 400,
   fontSize: '12px',
  },

  '& .ag-text-field-input': {
   backgroundColor: 'black !important',
  },

  '& .ag-header-icon': {
   color: 'black !important',
  },

  '& .ag-cell:focus': {
   border: 'none !important',
   outline: 'none',
  },

  '& .ag-row-selected': {
   backgroundColor: '#8180c3',
   color: 'black',
  },
  '& .ag-theme-alpine .ag-row-selected .ag-row-hover': {
   backgroundColor: 'red !important',
  },
  '& .MuiSvgIcon-root': {
   color: '#663d00',
   height: '20px',
  },

  '& .ag-theme-alpine .ag-row-selected': {
   backgroundColor: '#4abbff',
   height: '20px',
  },

  '& .ag-theme-alpine .ag-ltr .ag-cell-focus': {
   color: '#663d00',
  },
  '& .ag-root-wrapper.ag-layout-normal': {
   height: '100% !important',
  },
 },

 progressSpinner: {
  margin: 'auto',
  position: 'absolute',
  marginLeft: '50%',
  zIndex: 1,
 },
 input: {
  width: '200px',
  marginBottom: '30px',
  marginRight: '5px',
  padding: '7px',
  borderRadius: '5px',
  borderColor: '#D05F33',
  textAlign: 'end',
  color: '#D05F33',
  height: '10px',
  '& .MuiOutlinedInput-notchedOutline': {
   borderColor: '#D05F33 !important',
   color: '#D05F33 !important',
   fontSize: '12px !important',
  },
  '& .MuiOutlinedInput-input': {
   color: '#D05F33 !important',
   fontSize: '12px !important',
   alignItems: 'end',
   textAlign: 'end',
  },
 },
 searchIcon: {
  color: '#D05F33 !important',
 },
 pagination: {
  '& .MuiPaginationItem-root': {
   fontWeight: '600 !important',
   fontSize: '12px !important',
   color: '#FFB614',
  },
 },
});

const DataGrid = (props: any) => {
 const [gridApi, setGridApi] = useState<any>(null);
 const [gridColumnms, setGridColumnms] = useState<any>(null);
 const classes = useStyles();
 const dispatch = useDispatch<AppDispatch>();
 const gridRef = useRef<AgGridReact>(null);

 const detailsParams = (params: any) => {
  return {
   masterProps: props,
  };
 };
 const defaultColDef = {
  floatingFilter: false,
  sortable: true,
  filter: true,
  resizable: true,
  suppressContextMenu: true,
  autoHeaderHeight: true,
 };

 //  const contractDetails = useSelector(
 //   (state: RootState) => state.contractDetailData,
 //   shallowEqual,
 //  );

 //  const contractIdData = useSelector(
 //   (state: RootState) => state.contractId,
 //   shallowEqual,
 //  );

 const dataGridDetails = useMemo(() => {
  return DataGridDetails;
 }, []);

 const autoSizeAll = useCallback(() => {
  const allColumnIds: any[] = [];

  if (gridRef?.current?.columnApi) {
   const columns = gridRef?.current?.columnApi.getColumns();

   if (columns) {
    columns.forEach((column: any) => {
     allColumnIds.push(column.colId);
    });
   }
  }

  if (gridRef?.current?.columnApi) {
   gridRef?.current?.columnApi.autoSizeColumns(allColumnIds);
  }
 }, []);

 const onGridReady = (params: any) => {
  setGridApi(params.api);
  setGridColumnms(params.columnApi);
  if (params.api) {
   params.api.setHeaderHeight(40);
  }

  if (params.columnApi) {
   const allColumnIds: string[] = [];
   params.columnApi.getColumns().forEach((column: any) => {
    allColumnIds.push(column.getId());
   });
   params.columnApi.autoSizeColumns(allColumnIds);
  }
 };

 const onGridSizeChanged = () => {
  if (gridApi) {
   gridApi.sizeColumnsToFit();
  }
 };

 const onSelectionChanged = (e: any) => {};

 const onRowDataUpdated = () => {
  if (gridApi) {
   gridApi.sizeColumnsToFit();
  }

  // if (gridApi) {
  //  gridApi.forEachNode((node) => {
  //   node.setExpanded(false);
  //  });
  // }
 };

 const gridOptions: GridOptions = {
  columnDefs: props.columns,
  defaultColDef: {
   width: 150,
   sortable: true,
   resizable: true,
   suppressMenu: false,
  },
 };

 function getRowHeight(params: RowHeightParams): number | undefined | null {
  if (params.node.detail) {
   return 270;
  }
  return 40;
 }

 const rowClassRules = useMemo<RowClassRules>(() => {
  return {
   'row-gray': function (params) {
    return params.rowIndex % 2 === 0;
   },
   'row-non-gray': function (params) {
    return params.rowIndex % 2 !== 0;
   },
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 const onFirstDataRendered = (params: FirstDataRenderedEvent) => {
  autoSizeAll();

  if (gridApi) {
   gridApi.sizeColumnsToFit();
  }
 };

 const onGroupExpandedOrCollapsed = () => {};

 const onColumnVisible = (event: any) => {
  if (!gridColumnms) {
   return;
  }

  if (gridApi) {
   gridApi.sizeColumnsToFit();
  }
 };

 const onRowGroupOpened = (element: any) => {
  if (element.node.expanded) {
   if (gridApi) {
    gridApi.forEachNode((node) => {
     if (node?.data?.id === element?.data?.id) {
      node.setExpanded(true);
     } else {
      node.setExpanded(false);
     }
    });
   }
   if (
    props?.detailsRows &&
    props?.detailsRows.length > 0 &&
    props?.detailsType === 'appealQuestions'
   ) {
    const data = props.detailsRows.filter(
     (x) => x.requestNumber === element?.data?.requestNumber,
    );

    if (data && data.length > 0) {
     dispatch(contractDetailData(ContractConvertData(data)));
    }
   }

   if (
    props?.detailsRows &&
    props?.detailsRows.length > 0 &&
    props?.detailsType === 'appealOfficial'
   ) {
    const data = props.detailsRows.filter((x) => x.id === element?.data?.id);
    if (data && data.length > 0) {
     dispatch(contractDetailData(ContractConvertData(data)));
    }
   } else {
    srv.getConnections(element?.data?.id).then((response: any) => {
     if (response && response.length > 0) {
      dispatch(contractDetailData(response));
     }
    });
   }
  }
 };

 const onFilterChanged = (event: any) => {
  if (event?.columns.filter((x: any) => x.colId === 'contractDate')) {
  }
 };

 return (
  <React.Fragment>
   {props.showProgress ? (
    <div className={classes.progressSpinner}>
     <Box
      sx={{
       width: '35px',
      }}
     >
      <CircularProgress color="secondary" disableShrink />
     </Box>
    </div>
   ) : (
    ''
   )}

   <div
    className="ag-theme-alpine"
    style={{
     width: '100%',
     height: '500px',
     borderRadius: '10px',
     marginBottom: '20px',
     marginLeft: '20px',
     marginTop: '20px',
    }}
   >
    <AgGridReact
     className={classes.agHeader}
     defaultColDef={defaultColDef}
     rowData={ContractConvertData(props?.rows ? props.rows : [])}
     rowClassRules={rowClassRules}
     columnDefs={props.columns}
     onGridReady={onGridReady}
     onGridSizeChanged={onGridSizeChanged}
     rowSelection={'multiple'}
     onSelectionChanged={onSelectionChanged}
     onNewColumnsLoaded={onRowDataUpdated}
     gridOptions={gridOptions}
     pagination={props.usePagination ? false : true}
     paginationPageSize={20}
     ref={gridRef}
     localeText={agGridLocale}
     masterDetail={true}
     detailCellRendererParams={detailsParams}
     detailCellRenderer={dataGridDetails}
     onFirstDataRendered={onFirstDataRendered}
     suppressRowClickSelection={true}
     onExpandOrCollapseAll={onGroupExpandedOrCollapsed}
     onRowGroupOpened={onRowGroupOpened}
     suppressContextMenu={true}
     detailRowAutoHeight={false}
     rowModelType={'clientSide'}
     onColumnVisible={onColumnVisible}
     getRowHeight={getRowHeight}
     rowHeight={40}
     //onFilterChanged={(event: any) => onFilterChanged(event)}
    ></AgGridReact>
   </div>
  </React.Fragment>
 );
};

export default memo(DataGrid);
